import { VitalReport } from "../../components/report";

export default function VitalReportPage() {
  return <VitalReport />;
}
